import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import '../../../../themes/alert.js';
import { borderRadiusMedium } from '../../../../themes/borders.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import { BaseLink } from '../base-link/base-link.js';

const BaseStandardLink = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { className, disabled, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(BaseLink, {
        ...otherProps,
        className: classnames({
            'bf-link__standard': true,
            'bf-link__standard--disabled': disabled,
            [`${className}`]: className
        }),
        disabled: disabled,
        ref: ref
    });
});
const Link = styled(BaseStandardLink)`
  border-radius: ${borderRadiusMedium}px;
  color: ${({ theme })=>theme.link.textColor};
  display: inline-block;
  text-decoration: underline;

  &:hover {
    color: ${({ theme })=>theme.link.textColorHover};
  }

  &:active {
    color: ${({ theme })=>theme.link.textColorActive};
  }

  &:focus {
    outline: 0;
  }

  &:focus-visible {
    color: ${({ theme })=>theme.link.textColorFocus};
    outline: 2px solid ${({ theme })=>theme.link.outlineColorFocus};
    outline-offset: 2px;
  }

  &[aria-disabled='true'] {
    color: ${({ theme })=>theme.link.textColorDisabled};
    cursor: not-allowed;
  }
`;
const StandardLink = /*#__PURE__*/ forwardRef((props, ref)=>{
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(Link, {
        ...props,
        ref: ref
    }));
});

export { BaseStandardLink, StandardLink };
//# sourceMappingURL=standard-link.js.map
